import {
  createSelector,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit'
import type { RootState } from '@/redux/store'

export interface PartialMediaProps {
  hasPartialMedia: boolean
  mediaCode: number
  mediaNumber: string | null
  title: string | null
}
export interface MediaState {
  isPerkins: boolean
  partialMedia: PartialMediaProps
  headerMessage: string
  whatsNewHtml: string
}

const initialState: MediaState = {
  isPerkins: import.meta.env.VITE_PERKINS_THEME === 'true',
  partialMedia: {
    hasPartialMedia: false,
    mediaCode: 0,
    mediaNumber: '',
    title: '',
  },
  headerMessage: '',
  whatsNewHtml: '',
}

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    //Todo consider moving out into new app slice
    setIsPerkins: (state, action: PayloadAction<boolean>) => {
      state.isPerkins = action.payload
    },
    setPartialMedia: (state, action: PayloadAction<PartialMediaProps>) => {
      state.partialMedia.hasPartialMedia = action.payload.hasPartialMedia
      state.partialMedia.mediaCode = action.payload.mediaCode
      state.partialMedia.mediaNumber = action.payload.mediaNumber ?? ''
      state.partialMedia.title = action.payload.title ?? ''
    },
    setHeaderMessage: (state, action: PayloadAction<any>) => {
      state.headerMessage = action.payload
    },
    setWhatsNewHtml: (state, action: PayloadAction<any>) => {
      state.whatsNewHtml = action.payload
    },
  },
})

export const {
  setIsPerkins,
  setPartialMedia,
  setHeaderMessage,
  setWhatsNewHtml,
} = mediaSlice.actions

export const getMediaState = (state: RootState) => state.reducer.media

export const mediaSelectors = {
  selectIsPerkins: createSelector(getMediaState, (state) => state.isPerkins),
  selectPlatform: createSelector(getMediaState, (state) =>
    state.isPerkins ? 'Perkins' : 'Cat',
  ),
}

export default mediaSlice.reducer
